import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageAbout} from '../components/page-about';

export interface AboutPageProps {}

@inject(deps) @observer
export class AboutPage extends Component<AboutPageProps> {
  render() {
    const onSignUp = this.props.model.user.user
      ? null
      : this.handleSignUp;

    return (
      <PageAbout
        model={this.props.model.page.about}
        onSignUp={onSignUp}
        preload={this.props.controller.image.preloadImage}
      />
    )
  }

  handleSignUp = () => {
    this.props.controller.onboarding.openSignUpModal('/about');
  }
}